export const deviceSizes = {
    mobile: 950,
    pc: 1100,
};

// If you change the size you should change as well media query in :
// - NavigationButton.module.css
// - Sidebars.module.css
